import React from 'react';

export default function PageUnderConstruction() {
  return (
    <div>
      <div className="flex flex-col items-center justify-center bg-white text-center px-4 my-5">
        
        {/* Image Wrapper */}
        <div className="img-under-construction">
          <img
            className=""
            src="/images/p1.png"
            alt="p1"
          />
        </div>

        {/* Title */}
        <h1 className="text-2xl md:text-3xl font-bold text-blue-900 mt-6">
          Page Under Construction
        </h1>

        {/* Subtitle */}
        <p className="text-gray-600 mt-2 max-w-md">
          We’re working hard to bring you something amazing. Please check back
          soon!
        </p>
      </div>
    </div>
  );
}
